import { render, staticRenderFns } from "./ItemSlick.vue?vue&type=template&id=55480084&"
import script from "./ItemSlick.vue?vue&type=script&lang=js&"
export * from "./ItemSlick.vue?vue&type=script&lang=js&"
import style0 from "./ItemSlick.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports